import { NavLink, Outlet } from 'react-router-dom';

export default function Dashboard() {
  return (
    <div className="page dashboard">
      <div className="page-header">
        <div>
          <h1 className="page-title">Dashboard</h1>
          <p className="page-subtitle">Manage and review your test case sessions.</p>
        </div>
      </div>

      <nav className="dashboard-subnav">
        <NavLink
          to="my-submissions"
          className={({ isActive }) => `subnav-link ${isActive ? 'subnav-link-active' : ''}`}
        >
          My Submissions
        </NavLink>
        <NavLink
          to="assigned"
          className={({ isActive }) => `subnav-link ${isActive ? 'subnav-link-active' : ''}`}
        >
          Assigned for Review
        </NavLink>
        <NavLink
          to="all-sessions"
          className={({ isActive }) => `subnav-link ${isActive ? 'subnav-link-active' : ''}`}
        >
          All Sessions
        </NavLink>
      </nav>

      <div className="dashboard-content">
        <Outlet />
      </div>
    </div>
  );
}
